import FormEncode from "form-urlencoded";
export const buildRef = function (c) {
  const sstr = [];
  if (c.ref) {
    sstr.push(`${c.ref}/`);
  }

  sstr.push(`$${c.page}$`);
  sstr.push("?v=8");

  if (c.id) {
    sstr.push(`&id=${encodeURIComponent(c.id)}`);
  }
  if (c.event) {
    sstr.push(`&event=${encodeURIComponent(c.event)}`);
  }
  if (c.time) {
    sstr.push(`&time=${encodeURIComponent(c.time)}`);
  }
  if (c.spend) {
    sstr.push(`&spend=${encodeURIComponent(c.spend)}`);
  }
  if (c.area) {
    sstr.push(`&area=${encodeURIComponent(c.area)}`);
  }
  if (c.iid) {
    sstr.push(`&iid=${encodeURIComponent(c.iid)}`);
  }
  // if (c.method) {
  //   sstr.push(`&method=${encodeURIComponent(c.method)}`);
  // }
  if (c.idlist) {
    if (typeof c.idlist == "string" && c.idlist != "") {
      sstr.push(`&idlist=${encodeURIComponent(c.idlist)}`);
    }
    // else if (Array.isArray(c.idlist) && c.idlist.length > 0) {
    //   let il = "";
    //   for (let i = 0; i < c.idlist.length; i++) {
    //     if (i != 0) {
    //       il += "_";
    //     }
    //     il += c.idlist[i];
    //   }
    //   sstr.push(`&idlist=${encodeURIComponent(il)}`);
    // } else {
    //   //error format, drop it.
    // }
  }
  //console.log('buildRef result:' + sstr.join(''));
  return sstr.join("");
};
// 获取参数
export const getUrlParams = function (url: string, key: string) {
  let urlTemp = url
  // 为了兼容hash在url后边的情况
  if (/\?.+#/.test(url)) {
    urlTemp = url.match(/\?.+#/)[0]
    urlTemp = urlTemp.substring(0, urlTemp.length - 1)
  }
  const paramsObj = {};
  const paramsArr = urlTemp.substring(urlTemp.indexOf("?") + 1, urlTemp.length).split("&");
  
  for (var i = 0, len = paramsArr.length; i < len; i++) {
    const param = paramsArr[i];
    const flagArr = param.split("=");
    paramsObj[flagArr[0]] = flagArr[1];
  }

  return paramsObj[key] || "";
};
/**
 * 在url上增加参数
 * @param url 目标链接
 * @param key 参数名
 * @param value 参数值
 * @returns 最新的url
 * @kind 工具
 */
export const addParam = function (url, key, value) {
  if (/#.+\?/.test(url)) {
    if (url.indexOf(key + '=') === -1) {
      return `${url}&${key}=${value}`
    } else {
      url = url
        .replace(new RegExp(`[?&]${key}=[^&]*&?`, 'g'), (str) =>
          str[str.length - 1] === '&' ? `${str[0]}${key}=${value}&` : `${str[0]}${key}=${value}`
        );
      return url
    }

  }
  const hashReg = /#.+$/;
  let hash = url.match(hashReg) || [];
  hash = hash[0] || '';
  url = url
    .replace(hashReg, '')
    .replace(new RegExp(`[?&]${key}=[^&]*&?`, 'g'), (str) =>
      str[str.length - 1] === '&' ? str[0] : '',
    );
  let linkSymbol = '&';
  if (url.indexOf('?') === -1) {
    linkSymbol = '?';
  }
  return `${url}${linkSymbol}${key}=${value}${hash}`;
}
// 如果不传send方法，就用自己的
export const _sendStat = function (data, mode) {
  let url = 'https://beats.be.mi.com/mistore?format=json'
  if (mode === 'youpin') {
    url = 'https://beats.be.mi.com/xiaomiyoupin?format=json'
  }
  let realEvents = data.map(item => item.event)
  let newObj = {
    env: data[0].env,
    events: realEvents,
    specs: data[0].specs
  }
  // return fetch(origin + "/app/stat/visitv2", {
  return fetch(url, {
    method: "post",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(newObj) // 必须用这个方法处理一下，不然url会被decode
  }).catch(function (error) {
    console.log(error);
  });
};
// 投放接口
export const _adReport = function (data) {
  let origin = location.origin;
  return fetch(origin + "/mtop/navi/collection/report", {
    method: "post",
    credentials: 'include',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify([data])
  }).catch(function (error) {
    console.log(error);
  });
};

/**
 * 判断ua信息，从基础库copy过来的，目前只需要app信息
 */
export const uaTest = function () {
  const uaText = window.navigator && window.navigator.userAgent
  const miuinewapp =
    /miui\.hybrid/.test(uaText) && /com\.xiaomi\.youpin\./.test(uaText);
  let iOS_app_test =
    (uaText.match(/MiHome/) && uaText.match(/iOS/)) ||
    uaText.match(/^iOS-/) ||
    (uaText.match(/MIOTStore/) && uaText.match(/;I/));
  let iOS_app = Boolean(iOS_app_test)
  let android_app_test =
    uaText.match(/^Android-/) ||
    uaText.match(/MIOTStore/) ||
    uaText.match(/com\.xiaomi\.smarthome/);
  let android_app = Boolean(android_app_test)

  const app = (android_app || iOS_app) && !miuinewapp;
  return {
    app
  }
}

// 字符串转成对象
export const toObject = function (str) {
  const arr = str.split('&')
  const obj = {}
  arr.map(a => {
    let [key, val] = a.split('=')
    obj[key] = val
  })
  return obj
}

// 设置device_id
export const setDeviceId = function () {
  var chars = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [], i;
  for (i = 0; i < 16; i++) {
    uuid[i] = chars[0 | Math.random() * chars.length]
  };
  return uuid.join('');
}


// 删除对象空value
export const deleteNullVal = (obj: object) => {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
        delete obj[key]
      } else if (typeof obj[key] === 'object') {
        deleteNullVal(obj[key])
      }
    }
  }
  return obj
}

export const getOsName = function () {
  let webLog = {
    device: '',
    wechat: '',
    system: ''
  }
  let userAgent = navigator.userAgent
  // 获取微信版本
  let m1 = userAgent.match(/MicroMessenger.*?(?= )/)
  if (m1 && m1.length > 0) {
    webLog.wechat = m1[0]
  }
  // 苹果手机
  if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    // 获取设备名
    if (userAgent.includes('iPad')) {
      webLog.device = 'iPad'
    } else {
      webLog.device = 'iPhone'
    }
    // 获取操作系统版本
    m1 = userAgent.match(/iPhone OS .*?(?= )/)
    if (m1 && m1.length > 0) {
      webLog.system = m1[0]
    }
  }
  // 安卓手机
  if (userAgent.includes('Android')) {
    // 获取设备名
    m1 = userAgent.match(/Android.*; ?(.*(?= Build))/)
    if (m1 && m1.length > 1) {
      webLog.device = m1[1]
    }
    // 获取操作系统版本
    m1 = userAgent.match(/Android.*?(?=;)/)
    if (m1 && m1.length > 0) {
      webLog.system = m1[0]
    }
  }
  return webLog
} 
export const getDomain = function () {
  if(window) {
      var host = window.location.hostname;
      var hostAry = host.split('.');
      var size = hostAry.length;
      var domain = '.' + hostAry[size - 2] + '.' + hostAry[size - 1];
      return domain;
  }
}

export const isInYouPinApp = (): boolean => {
  // 通过 UA 来判定当前浏览器环境是否在 有品 APP 内
  const uaText = window.navigator && window.navigator.userAgent
  return uaText.indexOf('MIOTStore/')  > -1;
};
export const isInMishopApp = (): boolean => {
  // 通过 UA 来判定当前浏览器环境是否在 商城 APP
  const uaText = window.navigator && window.navigator.userAgent
  return uaText.indexOf('/Shop/') > -1;
};
export const isMishopWeb = (): boolean => {
  const curUrl = window?.location?.href;
  return curUrl && (curUrl.indexOf('mi.com') !== -1 || curUrl.indexOf('pdl=mishop') !== -1 || curUrl.indexOf('pdl=yundian') !== -1 || curUrl.indexOf('/mfbs/dghd') !== -1);
};
export const isYouPinWeb = (): boolean => {
  const curUrl = window?.location?.href;
  return curUrl && curUrl.indexOf('xiaomiyoupin.com') !== -1;
};
export const isMatchApp = (): boolean => {
  if (isMishopWeb() && isInMishopApp()) {
    return true;
  }
  if (isYouPinWeb() && isInYouPinApp()) {
    return true;
  }
  return false;
}